import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/internal/operators/map";
import { Customers } from "src/app/models/customer/customer";
import { liveData } from "src/app/models/dashboard/livedata";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class customerService {

    constructor(private http: HttpClient) {
    }

    baseUrl = environment.Base_URL

    getAllCustomers(obj): Observable<Customers[]> {
        console.log('dataRetrivalPolicy', obj.dataRetrivalPolicy)
        if (obj.customerType == 'all') {
            obj.customertype == ''
        }
        var querryString = ''

        if (obj.custId) {
            querryString += 'custId=' + obj.custId + '&'
        }
        if (obj.companyName) {
            querryString += 'companyName=' + obj.companyName + '&'
        }
        if (obj.farmerName) {
            querryString += 'farmerName=' + obj.farmerName + '&'
        }
        if (obj.mobileNumber) {
            querryString += 'mobileNumber=' + obj.mobileNumber + '&'
        }
        if (obj.customerType) {
            querryString += 'customerType=' + obj.customerType + '&';
        }
        if (obj.fromDate) {
            querryString += 'FromDate=' + obj.fromDate + '&'
        }
        if (obj.toDate) {
            querryString += 'ToDate=' + obj.toDate + '&'
        }
        if (obj.dataRetrivalPolicy) {
            querryString += obj.dataRetrivalPolicy
        }
        if (querryString == '') {

            return this.http.get<Customers[]>
                (this.baseUrl + 'CustomerSignUp/GetAllCustomerSignUpAdminHeirarchyData/' + obj.dataRetrivalPolicy + '/' + obj.aggregatorCode + '/' + obj.page + '/' + obj.pageSize)
                .pipe(map((data: Customers[]) => {
                    const transformedData = data
                    return transformedData;
                }));
        } else {

            return this.http.get<Customers[]>
                (this.baseUrl + 'CustomerSignUp/GetAllCustomerSignUpAdminHeirarchyData/' + obj.dataRetrivalPolicy + '/' + obj.aggregatorCode + '/' + obj.page + '/' + obj.pageSize + '?' + querryString)
                .pipe(map((data: Customers[]) => {
                    const transformedData = data
                    return transformedData;
                }));
        }

    }

    getAllCommudity(): Observable<any> {
        return this.http.get(this.baseUrl + 'CommodityMaster/GetAllCommodityTypeData/1', { observe: 'response' })
    }

    customerRegisteration(UserData): Observable<Customers> {
        return this.http.post<Customers>(this.baseUrl + 'CustomerSignUp/AddCustomerSignUp_V_1_0_1', UserData)
            .pipe(map((data: Customers) => {
                const transformedData = data
                return transformedData;
            }));
    }

    updateCustomer(UserData): Observable<any> {
        return this.http.put<any>(this.baseUrl + 'CustomerSignUp/UpdateCustomerSignUp', UserData, { observe: 'response' })
    }

    uploadDocuments(UserData): Observable<any> {
        return this.http.post(this.baseUrl + 'CustomerDocument/AddCustomerDocumentList', UserData, { observe: 'response' });
    }

    getDocuments(id): Observable<any> {
        return this.http.get(this.baseUrl + 'CustomerDocument/GetCustomerDocumentByCustomerDataIdCustomerData/' + id, { observe: 'response' })
    }

    UploadProduct(UserData) {
        return this.http.post(this.baseUrl + 'CustomerCommidity/AddCustomerDataHasCommodityType', UserData, { observe: 'response' });
    }

    getProductByCustomer(id) {
        return this.http.get(this.baseUrl + 'CustomerCommidity/GetCustomerCommidityByCommodityMasterId/' + id,);
    }

    deleteCustomer(idCustomerData): Observable<any> {
        return this.http.put(this.baseUrl + 'CustomerSignUp/DeleteCustomerData/', idCustomerData)
    }

    uploadCSV(data, customerType): Observable<any> {
        if (customerType == "Farmer") {
            // var obj1 = {
            //     "addCustFarmerData": data
            // }
            // return this.http.post<any>(this.baseUrl+'CustomerSignUp/AddCustSignUpListForFarmer',obj1, { observe:'response'})
            // return this.http.post<any>(this.baseUrl+'CustomerSignUp/UploadCustSignUpListForFarmer',obj1, { observe:'response'})
        } else if (customerType == 'Company') {
            var obj2 = {
                "addCustCompanyData": data
            }
            return this.http.post<any>(this.baseUrl + 'CustomerSignUp/AddCustSignUpListForCompany', obj2, { observe: 'response' })
        } else {
            var obj3 = {
                "addCustTraderData": data
            }
            return this.http.post<any>(this.baseUrl + 'CustomerSignUp/AddCustSignUpListForTrader', obj3, { observe: 'response' })
        }

    }

    //
    uploadExcelFile(formData: FormData): Observable<any> {
        return this.http.post<any>(this.baseUrl + 'CustomerSignUp/UploadCustSignUpListForFarmer', formData)
    }

    getLiveData(id): Observable<liveData[]> {
        return this.http.get<liveData[]>(this.baseUrl + 'MarketPlace/GetAllMarketPlaceBidList/live/1/25' + id)
            .pipe(map((data: liveData[]) => {
                const transformedData = data
                return transformedData;
            }));
    }

    getAssociatesByCustomerId(id): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'CustomerSignUp/GetAssociatesByCustomer/' + id)
    }
    updateEditDocument(obj): Observable<any> {
        return this.http.put(this.baseUrl + 'CustomerDocument/UpdateCustomerDocument', obj)
    }

    getAggregatorSearchContent(code, val): Observable<any> {
        return this.http.get(this.baseUrl + `Aggregation/GetAllAggregatorDropDown_Hirarchy/${code}?AggregatorName=${val}`)
    }

    downloadFile(data, filename) {
        var csvData = this.ConvertToCSV(data, [
            // "CustomerType",
            "CompanyName",
            "GST",
            "FirstName",
            "LastName",
            "Gender",
            "eMailId",
            "MobileNumber",
            "LandNumber",
            "YourAddress",
            "CityTownVillage",
            "District",
            "Taluka",
            "PinCode",
            "State",
            "Password",
            // "ProfileImage",
            "PanCard",
            "AadharCard",
            "AggregatorName",
            "BankName",
            "BankBranch",
            "BankAccountNumber",
            "IfscCode",
            "InsertDate"]);
        console.log(csvData)
        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    ConvertToCSV(objArray, headerList) {
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = '';
        for (let index in headerList) {
            row += headerList[index] + ',';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in headerList) {
                let head = headerList[index];
                line += array[i][head] + ',';
            }
            str += line + '\r\n';
        }
        return str;
    }

    getCustomerUploadErrorReport(date): Observable<any> {
        return this.http.get(this.baseUrl + `CustomerSignUp/DownloadCustomerUploadError/${date}`, { observe: 'response', responseType: 'blob' });
    }

    getcomodityTypeAndNames() {
        return this.http.get(this.baseUrl + 'CommodityMaster/GetCommodityTypeWithName');
    }
}